import {
  ERROR,
  SUCCESS,
  GET_CURRENT_PLAN,
  PLACE_ORDER,
  GET_CURRENT_PLAN_ERROR,
  CLEAR_STORE,
} from "../reducers/index";
import axios from "axios";
import { getCouponFromUrl } from "./../../../../helpers/functions";

export const getQuoteSuccess = (content) => ({
  type: SUCCESS,
  payload: content,
});

export const getQuoteError = (content) => ({
  type: ERROR,
  payload: content,
});

export const clearStore = () => ({
  type: CLEAR_STORE,
});

export const getQuote =
  (planId, data, cb = () => {}, errorCb = () => {}) =>
  async (dispatch, getState) => {
    let coupon = "";
    if (window.location.pathname.indexOf("coupon_") > -1) {
      coupon = getCouponFromUrl(window.location.pathname) || "";
    }
    const { api } = getState().paths;
    const url = `${api}/quote/plan/${planId}`;
    const body = {
      billingAddress: {
        city: data["billing-city"].value || "",
        country: data["billing-country"].value || "",
        postalCode: data["billing-zip"].value || "",
        stateProvince: data["billing-state"].value || "",
        street: data["billing-address-1"].value || "",
        street2: data["billing-address-2"].value || "",
      },
      coupon: coupon.length > 0 ? coupon : null,
    };
    let tries = 0;
    async function tryToGetQuote() {
      async function handleGetQuoteError() {
        if (tries <= 5) {
          await tryToGetQuote();
        } else {
          const plan = getState().quote.currentPlan;
          dispatch(
            getQuoteSuccess({
              priceOutput: {
                calculatedTax: "0.00",
                total: plan.price,
                jwtSignature: getState().quote.jwtSignature,
              },
            }),
          );
          errorCb();
        }
      }
      tries++;
      try {
        const response = (await axios.post(url, body)).data;
        if (!parseFloat(response.priceOutput.calculatedTax)) {
          await handleGetQuoteError();
        }
        dispatch(getQuoteSuccess(response));
        cb();
      } catch (e) {
        dispatch(getQuoteError(e.toString()));
        if (doesQuoteResponseContainsError(e)) {
          errorCb(e.response.data.endUserMessage);
        } else {
          errorCb();
        }
      }
    }
    await tryToGetQuote();
  };

export const getCurrentPlan = (cb) => async (dispatch, getState) => {
  const planId = window.location.pathname.split("/")[3];
  let coupon = "";
  if (window.location.pathname.indexOf("coupon_") > -1) {
    coupon = getCouponFromUrl(window.location.pathname) || "";
  }
  let { subscriptionPlans } = getState().subscription;
  if (!subscriptionPlans) {
    const url = `${getState().paths.api}/plan/${planId}${
      coupon.length > 0 ? `?coupon=${coupon}` : ""
    }`;
    await axios
      .get(url)
      .then((response) => {
        dispatch({
          type: GET_CURRENT_PLAN,
          payload: response.data,
        });
      })
      .catch((error) => {
        const { data } = error.response;
        dispatch({
          type: GET_CURRENT_PLAN_ERROR,
          payload: {
            status: error.response.status,
            errorMessage: data ? data.endUserMessage : error.toString(),
          },
        });
      });
  } else {
    subscriptionPlans = subscriptionPlans.find((el) => el.id === planId);
    dispatch({
      type: GET_CURRENT_PLAN,
      payload: subscriptionPlans,
    });
  }
  if (cb) {
    cb();
  }
};

export const placeOrder =
  (data, stripe, cb, errorCb) => async (dispatch, getState) => {
    if (stripe) {
      const {
        paths: { api },
        quote: {
          currentPlan: { id: planId, productOfferingId },
          jwtSignature,
        },
      } = getState();
      let coupon = "";
      if (window.location.pathname.indexOf("coupon_") > -1) {
        coupon = getCouponFromUrl(window.location.pathname) || "";
      }
      const url = `${api}/subscription/activation`;
      let temporaryToken;
      try {
        temporaryToken = (await stripe.createToken()).token.id;
      } catch (e) {
        return errorCb();
      }
      const body = {
        firstName: data["billing-first-name"].value,
        lastName: data["billing-last-name"].value,
        billingAddress: processBilling(data),
        planId,
        productOfferingId,
        temporaryToken,
        verificationToken: jwtSignature,
        coupon: coupon.length > 0 ? coupon : null,
      };
      try {
        await axios.post(url, body);
        dispatch({ type: PLACE_ORDER });
        cb();
      } catch (e) {
        if (isRequestContainsErrorMessage(e)) {
          errorCb(e.response.data.body.endUserMessage);
        } else {
          errorCb();
          throw e;
        }
      }
    }
  };

function processBilling(data) {
  return {
    city: data["billing-city"].value || "",
    country: data["billing-country"].value || "",
    postalCode: data["billing-zip"].value || "",
    stateProvince: data["billing-state"].value || "",
    street: data["billing-address-1"].value || "",
    street2: data["billing-address-2"].value || "",
  };
}

function doesQuoteResponseContainsError(e) {
  return (
    e.response &&
    e.response.status === 400 &&
    e.response.data &&
    e.response.data.endUserMessage
  );
}

function isRequestContainsErrorMessage(e) {
  return (
    e.response &&
    e.response.status === 400 &&
    e.response.data &&
    e.response.data.body.endUserMessage
  );
}
